import { SecureSettleInfo } from '@generated/graphql'
import { ENV } from '@util/env'
import { useEffect, useRef } from 'react'

export const RedirectForm = (secureInfo: SecureSettleInfo) => {
  const formRef = useRef<HTMLFormElement>(null!)

  useEffect(() => {
    formRef.current?.submit()
  }, [])
  return (
    <form method="POST" action={decodeURIComponent(secureInfo?.tds2_url)} ref={formRef}>
      <input name="PaReq" type="hidden" value={decodeURIComponent(secureInfo?.pareq)} />
      <input name="TermUrl" type="hidden" value={`${ENV.API_HOST_URL}/api/crons/settle_secure`} />
      <input name="MD" type="hidden" value={secureInfo.payment_order_id} />
    </form>
  )
}
